module.exports = __webpack_public_path__ + "static/img/fellowChicken2.293a8aa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/fellowChicken2.png
// module id = FXKO
// module chunks = 2